export const news = {
  "could-president-trumps-rallies-sway-voters-in-less-than-two-weeks-0": {
    title: "Could President Trump's rallies sway voters in less than two weeks?",
    image: "https://kubrick.htvapps.com/vidthumb/9385be0f-61df-44d1-a820-52c9e0018124/fa233a4b-0f11-451f-b3cb-57174bf6a9d5.png",
    paragraph: "ONLY AVAILABLE IN PAID PLANS",
    link: "https://www.wmur.com/article/president-trumps-rallies-voters-midterms-2026/74201549"
  },

  "three-generations-all-first-time-passes-powertitan-30-validates-system-level-safety-under-extreme-large-scale-fire-test-1": {
    title: "Three Generations, All First-Time Passes: PowerTitan 3.0 Validates System-Level Safety Under Extreme Large-Scale Fire Test",
    image: "https://mmx.prnewswire.com/media/MS2017887/20261021050116EDT_image_1.jpg?id=OA3031705&p=original",
    paragraph: "ONLY AVAILABLE IN PAID PLANS",
    link: "https://www.prnewswire.co.uk/news-releases/three-generations-all-first-time-passes-powertitan-3-0-validates-system-level-safety-under-extreme-large-scale-fire-test-302915315.html"
  },

  "david-marcus-the-5-factors-that-could-decide-michigans-tight-and-ugly-senate-race-2": {
    title: "DAVID MARCUS: The 5 factors that could decide Michigan's tight and ugly senate race",
    image: "https://i.headtopics.com/images/2026/10/21/foxnews/david-marcus-the-5-factors-that-could-decide-michi-david-marcus-the-5-factors-that-could-decide-michi-D974638F4EB3232DD3DAA615ADFEC6C7-16x9.webp",
    paragraph: "ONLY AVAILABLE IN PAID PLANS",
    link: "https://us.headtopics.com/news/david-marcus-the-5-factors-that-could-decide-michigan-s-89040359"
  },

  "should-andy-burnham-approve-more-north-sea-drilling-after-jackdaw-3": {
    title: "Should Andy Burnham approve more North Sea drilling after Jackdaw?",
    image: "https://cdn.images.express.co.uk/img/dynamic/139/237x141/2259142_1.jpg",
    paragraph: "ONLY AVAILABLE IN PAID PLANS",
    link: "https://www.express.co.uk/news/politics/2259142/andy-burnham-north-sea-jackdaw"
  },

  "council-considers-program-to-revitalize-buildings-4": {
    title: "Council considers program to revitalize buildings",
    image: "https://www.hawaiitribune-herald.com/wp-content/uploads/sites/6/2026/10/web1_Ashley_Kierkiewicz_2023_WEB--1-.jpg",
    paragraph: "ONLY AVAILABLE IN PAID PLANS",
    link: "https://www.hawaiitribune-herald.com/2026/10/21/hawaii-news/council-considers-program-to-revitalize-buildings/"
  }
};
